<div class="nav_breadcrumb simple">
  <span
    class="material-icons home"
    [routerLink]="redirectPath"
    [queryParams]="roleParam"
  >
    home
  </span>

  <span class="breadcrumb-separator"> > </span>

  <div *ngFor="let bcElement of bcLoadedData; let last = last">
    <ng-container
      *ngIf="bcElement.bc_name == this.plReportName; else breadcrumbWithRoute"
    >
      <span class="breadcrumb-link">
        {{ bcElement.bc_name }}
      </span>
    </ng-container>

    <ng-template #breadcrumbWithRoute>
      <a
        class="breadcrumb-link"
        *ngIf="
          !last &&
          role != 'advertiser_reporting_user' &&
          role != 'agency_advertiser_reporting_user'
        "
        routerLink="{{ bcElement.path }}"
        [queryParams]="bcElement.params"
      >
        {{ bcElement.bc_name }}
      </a>
    </ng-template>

    <span
      class="breadcrumb-link"
      *ngIf="
        !last &&
        (role == 'advertiser_reporting_user' ||
          role == 'agency_advertiser_reporting_user')
      "
    >
      {{ bcElement.bc_name }}
    </span>

    <span *ngIf="last">
      {{
        bcElement.bc_name != "edit"
          ? breadcrumbsName[bcElement.bc_name]
          : (edit_permission ? "EDIT: " : "READ ONLY: ") +
            edit_name +
            " (" +
            edit_id +
            ")"
      }}
    </span>

    <span class="breadcrumb-separator mt-2" *ngIf="!last">></span>
  </div>
</div>
